export const isAndroid = function () {
  let isAndroid;
  if (window.androidApi != null) {
    isAndroid = true;
  }
  else {
    isAndroid = false;
  }
  return isAndroid;
}
// 获取sessionId casCookie
export const getUserInfo = function () {
  let userId = '';
  let casCookie = '';
  let sessionId = '';
  if (!isAndroid()) {
    try {
      const person = iosGetPerson();
      userId = person.userId;
      sessionId = person.sessionId;
      casCookie = person.casCookie;
    } catch (error) {
      console.log('ios session', error);
    }
  } else {
    try {
      let tempObj = window.androidApi.getBasicPersionData();
      let parseObj = JSON.parse(tempObj);
      userId = parseObj.userId;
      sessionId = parseObj.sessionId;
      casCookie = parseObj.casCookie;
    } catch (error) {
      console.log('android session', error);
    }
  }

  return {
    userId: userId,
    casCookie: casCookie,
    sessionId: sessionId
  }
}




// WEBPACK FOOTER //
// ./src/libs/utils.js